<template>
    <li class="subMenu" :class="{subMenuActive: menuActiveName == router.name}">
        <router-link :to="{name: router.name}" @click="hiddenMenus()">
            <span> {{ name }} </span>
        </router-link>
    </li>
</template>

<script setup>
    import { computed, onMounted, inject } from 'vue';
    import { useStore } from 'vuex';

    // Props
    const props = defineProps({
        name: String,
        router: Object
    });

    // Store
    const store = useStore();

    // Computed properties
    const menuActiveName = computed(() => store.state.menuActiveName);

    // Dependency injections
    const activateParentMenu = inject('activateParentMenu', null);

    // Event handlers
    const hiddenMenus = () => {
        if (activateParentMenu) {
            activateParentMenu();
        }
        // Fechar menu mobile quando navegar em submenu
        if (window.innerWidth <= 768) {
            store.commit('closeMobileMenu');
        }
    };

    // Lifecycle hooks
    onMounted(() => {
        if (menuActiveName.value === props.router.name && activateParentMenu) {
            activateParentMenu();
        }
    });
</script>

<style lang="scss">
    .subMenu{
        position: relative;
        padding: 0.25em 0;
        transition: var(--transitionDefault);
        cursor: pointer;
        margin-bottom: 0.125em;

        & span{
            font-size: var(--fontSizeXs);
            font-weight: var(--fontWeightNormal);
            letter-spacing: 0.01em;
            margin-left: 2.5em;
            display: block;
            padding: 0.625em 1em;
            border-radius: var(--borderRadiusSmall);
            transition: var(--transitionDefault);
            position: relative;
            z-index: 2;
            color: var(--textMuted);
        }

        &:before{
            content: '';
            position: absolute;
            top: 0;
            left: 1.25em;
            width: 1px;
            height: 100%;
            background: var(--borderColorMedium);
            opacity: 0.6;
            transition: var(--transitionDefault);
        }
        
        &:after{
            content: '';
            position: absolute;
            top: 50%;
            left: 1.125em;
            width: 0.25em;
            height: 0.25em;
            border-radius: var(--borderRadiusFull);
            background: var(--colorGrayLight500);
            z-index: 3;
            transform: translateY(-50%);
            transition: var(--transitionDefault);
        }

        &:hover{
            & span{
                color: var(--linkColor);
                padding-left: 1.25em;
            }
            
            &:before{
                background: var(--linkColor);
                opacity: 0.3;
            }
            
            &:after{
                background: var(--linkColor);
                transform: translateY(-50%) scale(1.5);
            }
        }
    }

    .subMenuActive{
        & span{
            color: var(--linkColor);
            font-weight: var(--fontWeightMedium);
            border-left-color: var(--linkColor);
            padding-left: 1.25em;
        }
        
        &:before{
            background: var(--linkColor);
            opacity: 0.4;
        }

        &:after{
            background: var(--linkColor);
            transform: translateY(-50%) scale(1.8);
        }
    }
</style>